import React from "react";
import { useDarkMode } from "../../contexts/DarkModeContext";
import { getUserRole } from "../../utils/visibilityUtils";

export type AttendanceAdminTab = "my" | "team";

interface AttendanceAdminTabsProps {
  activeTab: AttendanceAdminTab;
  onTabChange: (tab: AttendanceAdminTab) => void;
}

const AttendanceAdminTabs: React.FC<AttendanceAdminTabsProps> = ( {
  activeTab,
  onTabChange,
}) => {
  const { isDarkMode } = useDarkMode();
  const roleId = getUserRole();

  if (roleId === 2) {
    return null;
  }

  const tabButtonStyles = (isActive: boolean): React.CSSProperties => ({
    padding: "10px 0",
    backgroundColor: "transparent",
    border: "none",
    borderBottom: isActive ? "2px solid #34D399" : "2px solid transparent",
    cursor: "pointer",
    fontSize: "13px",
    fontWeight: 600,
    letterSpacing: "0.04em",
    color: isActive
      ? isDarkMode
        ? "#f1f5f9"
        : "#0F172A"
      : isDarkMode
        ? "#94a3b8"
        : "#64748B",
    marginRight: "20px",
    transition: "all 0.2s ease",
  });

  return (
    <div
      style={{
        display: "flex",
        gap: "8px",
        borderBottom: isDarkMode ? "1px solid #334155" : "1px solid #E5E7EB",
        padding: "0 4px",
        marginBottom: "12px",
      }}
    >
      <button
        type="button"
        style={tabButtonStyles(activeTab === "my")}
        onClick={() => onTabChange("my")}
        aria-selected={activeTab === "my"}
      >
        MY
      </button>
      <button
        type="button"
        style={tabButtonStyles(activeTab === "team")}
        onClick={() => onTabChange("team")}
        aria-selected={activeTab === "team"}
      >
        TEAM
      </button>
    </div>
  );
};


export default AttendanceAdminTabs;
